import { writable } from 'svelte/store';
import { getRandomColor } from "../utils.js";
import { darkenHSL } from '../utils.js';

export const bgColor = writable(getRandomColor());

function newBgColor() {
  setTimeout(() => {
    const newColor = getRandomColor();
    changeFaviconColor(newColor);
    changeScrollBarColor(newColor);
    bgColor.set(newColor);
    newBgColor();

  }, 1500 + Math.floor(Math.random() * 1500));
}

export function changeColor() {
  const newColor = getRandomColor();
  changeFaviconColor(newColor);
  changeScrollBarColor(newColor);
  bgColor.set(newColor);
}

function changeFaviconColor(color) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="97" height="97" viewBox="0 0 97 97">
  <defs>
    <style>
      .cls-1 {
        fill: ${color};
      }

      .cls-2 {
        fill: #fff;
        fill-rule: evenodd;
      }
    </style>
  </defs>
  <circle class="cls-1" cx="48.5" cy="48.5" r="48.5"/>
  <path id="Color_Fill_1" data-name="Color Fill 1" class="cls-2" d="M7.054,60.609L25.865,30.174l38.293-8.116,5.375,6.087V18h6.924V36.017S84.742,48.713,87,51.478C81.263,66.961,72.826,61.466,52.563,74,50.61,71.6,28.173,37.032,28.173,37.032S11.621,63.871,10.705,65.438C6.234,65.64,7.054,60.609,7.054,60.609Z"/>
</svg>`;
  const favicon = document.getElementById('dynamic-favicon');
  favicon.href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

function changeScrollBarColor(color) {
  const cssStr = `
	::-webkit-scrollbar-thumb {
		background: ${darkenHSL(color, 5)};
		border: 8px none;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: ${darkenHSL(color, 10)};
      }

      ::-webkit-scrollbar-thumb:active {
        background: ${darkenHSL(color, 50)};
	}
  
	::-webkit-scrollbar-track {
		background: #414141;
		border: 0px none #00000000;
    }
    
    ::-webkit-scrollbar-track:hover {
      background: #00000000;
      }

      ::-webkit-scrollbar-track:active {
		background: #33333388;
    }
    
    ::-webkit-scrollbar-corner {
      background: transparent;
      }`
  const scrollbarCss = document.getElementById('dynamic-scrollbar-color');

  scrollbarCss.textContent = cssStr;

  document.body.style.overflow = 'hidden';
  void document.body.offsetWidth; // Trigger reflow
  document.body.style.overflowY = 'scroll';
  document.body.style.overflowX = 'hidden';
}

newBgColor();